export default {
  pleaseSelect:'選んでください'
};
